import { RbacRole } from '@axilon-apps/domains-identity/constants'
import { useGetAuthzMeQuery } from '@axilon-apps/domains-ontology-ui-state'

/** Global admins may see Configure and create agents from chat. */
export function isGlobalAdmin(roles: readonly string[] | undefined): boolean {
  return roles?.includes(RbacRole.GlobalAdmin) === true
}

/** Whether the current user is a global admin. False while authz is loading. */
export function useIsGlobalAdmin(): boolean {
  const { data: authz } = useGetAuthzMeQuery()
  return isGlobalAdmin(authz?.roles)
}
